import { useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./components/ui";
import Router from "./routes/Router";
import "./styles/desktop-page-system.css";

const KOREAN_LANG = "ko-KR";
const KOREAN_TEXT_INPUT_SELECTOR = [
  "textarea:not(.ds-input)",
  "input:not(.ds-input):not([type])",
  'input:not(.ds-input)[type="text"]',
  'input:not(.ds-input)[type="search"]',
  'input:not(.ds-input)[type="tel"]',
  '[contenteditable="true"]',
].join(", ");

function applyKoreanInputHints(root) {
  if (!root || typeof root.querySelectorAll !== "function") {
    return;
  }

  const elements = [];

  if (root instanceof Element && root.matches(KOREAN_TEXT_INPUT_SELECTOR)) {
    elements.push(root);
  }

  root.querySelectorAll(KOREAN_TEXT_INPUT_SELECTOR).forEach((element) => {
    elements.push(element);
  });

  elements.forEach((element) => {
    element.setAttribute("lang", KOREAN_LANG);
    element.setAttribute("autocapitalize", "off");
    element.setAttribute("autocorrect", "off");

    if (
      element instanceof HTMLInputElement ||
      element instanceof HTMLTextAreaElement
    ) {
      element.spellcheck = false;
    }
  });
}

export default function App() {
  useEffect(() => {
    document.documentElement.setAttribute("lang", KOREAN_LANG);
    document.body?.setAttribute("lang", KOREAN_LANG);
    applyKoreanInputHints(document);

    if (!document.body) {
      return undefined;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            applyKoreanInputHints(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return (
    <AuthProvider>
      <ToastProvider>
        <Router />
      </ToastProvider>
    </AuthProvider>
  );
}
